import type { Metier } from "models";
import { useState, useEffect } from "react";
import { metiersService } from "services";
import { useSnackbarErrorHandler } from "utils/errorHandling";
import { sortingUtil } from "utils";

interface IUseMetier {
  metiers: Array<Metier>;
  isMetiersLoading: boolean;
}

/**
 * Cherche et retourne la liste de tous les métiers, pré-rangés.
 * @returns `{ metiers, isMetiersLoading }`
 */
export function useMetiers(): IUseMetier {
  const [metiers, setMetiers] = useState<Array<Metier>>([]);
  const { catchErrors: catchMetiersErrors, isLoading: isMetiersLoading } =
    useSnackbarErrorHandler();

  useEffect(() => {
    async function getMetiers(): Promise<void> {
      const _metiers = await metiersService.getAll();
      _metiers.sort(sortingUtil.sortMetiers);
      setMetiers(_metiers);
    }
    void catchMetiersErrors(getMetiers);
  }, [catchMetiersErrors]);

  return { metiers, isMetiersLoading };
}
